/* Hoppo — lightweight scroll-reveal. Adds .is-in to .hoppo-reveal elements
   when they enter the viewport. No dependencies. */
(function () {
  function init() {
    var els = document.querySelectorAll('.hoppo-reveal:not(.is-in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();

/* Hoppo — dialogs. Any element with [data-hoppo-dialog="<id>"] opens the
   <dialog> with that id. Closing is handled natively by the form[method=dialog]
   button and Esc; this only adds click-outside-to-close. Delegated, so it keeps
   working for sections re-rendered in the theme editor. */
(function () {
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-hoppo-dialog]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-hoppo-dialog'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    // Clicking the backdrop lands on the dialog element itself, not its content.
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('hoppo-dialog')) {
      event.target.close();
    }
  });
})();

/* 18+ leeftijdspoort — schermvullend, blokkeert de site.
   Visitor enters a birth date; 18+ passes (remembered in localStorage), younger
   is redirected away. hoppo-head already added .hoppo-age-verified for returning
   visitors so the gate never paints for them. */
(function () {
  var gate = document.getElementById('hoppo-age');
  if (!gate) return;

  var KEY = 'hoppo-age-ok';
  var root = document.documentElement;

  // Returning verified visitor: gate is hidden by CSS, nothing to do.
  if (root.classList.contains('hoppo-age-verified')) return;

  // Lock scrolling behind the gate while it blocks the page.
  root.classList.add('hoppo-age-lock');

  var form = document.getElementById('hoppo-age-form');
  var errorEl = document.getElementById('hoppo-age-error');
  if (!form) return;

  var minAge = parseInt(gate.getAttribute('data-min-age'), 10) || 18;
  var redirect = gate.getAttribute('data-redirect') || '';

  function pass() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    root.classList.remove('hoppo-age-lock');
    if (gate.parentNode) gate.parentNode.removeChild(gate);
  }

  function deny() {
    if (redirect) {
      window.location.replace(redirect);
      return;
    }
    var box = gate.querySelector('.hoppo-age__box');
    if (box) {
      var p = document.createElement('p');
      p.className = 'hoppo-age__text';
      p.textContent = gate.getAttribute('data-denied') || 'Je moet 18 jaar of ouder zijn om Hoppo te bezoeken.';
      box.innerHTML = '';
      box.appendChild(p);
    }
  }

  /* Auto-doorspringen tussen de datumvakjes: zodra Dag (2 cijfers) of Maand
     (2 cijfers) vol is, gaat de focus naar het volgende vakje. Backspace in een
     leeg vakje springt terug. Niet-cijfers worden er direct uitgefilterd. */
  var fields = [form.day, form.month, form.year].filter(Boolean);

  fields.forEach(function (input, index) {
    var max = input.maxLength > 0 ? input.maxLength : 4;

    input.addEventListener('input', function () {
      var digits = input.value.replace(/\D/g, '').slice(0, max);
      var atEnd = input.selectionStart === input.value.length;
      if (digits !== input.value) input.value = digits;

      var next = fields[index + 1];
      // Alleen doorspringen bij typen aan het eind, niet bij corrigeren midden
      // in een gevuld vakje.
      if (next && atEnd && digits.length === max) {
        next.focus();
        next.select();
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Backspace' || input.value !== '') return;
      var prev = fields[index - 1];
      if (!prev) return;
      event.preventDefault();
      prev.focus();
      prev.setSelectionRange(prev.value.length, prev.value.length);
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var day = parseInt(form.day.value, 10);
    var month = parseInt(form.month.value, 10);
    var year = parseInt(form.year.value, 10);
    var now = new Date();

    var valid =
      day >= 1 && day <= 31 &&
      month >= 1 && month <= 12 &&
      year >= 1900 && year <= now.getFullYear();

    if (!valid) {
      if (errorEl) errorEl.hidden = false;
      return;
    }
    if (errorEl) errorEl.hidden = true;

    var age = now.getFullYear() - year;
    if (now.getMonth() + 1 < month || (now.getMonth() + 1 === month && now.getDate() < day)) {
      age -= 1;
    }

    if (age >= minAge) {
      pass();
    } else {
      deny();
    }
  });
})();
